import React, { useState,useEffect } from 'react';
import { Button, Modal,message } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import FlowDetailsModal from './FlowDetailsModal'; // import your modal component
import FlowDetailsModalOnFlowScreen from './FlowDetailsModalOnFlowScreen';
//import { FolderMinus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";


const TopUtilityBar = ({ selectedFlowData , name = 'Flow Name', formdata, object,generateFlowBody }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [isActive, setIsActive] = useState(false);


  const openModal = () => setModalVisible(true);
  const closeModal = () => setModalVisible(false);
  const [flowData,setFlowData] = useState(formdata);
  const navigate = useNavigate();
  useEffect(() => {
    if (!formdata && selectedFlowData) {
      setFlowData(selectedFlowData);
      setIsActive(selectedFlowData.active);
    }
  }, [formdata, selectedFlowData]);

  const onSave = async () => {
    console.log('saving flow...',flowData);
    const body = generateFlowBody(flowData?.name,flowData?.apiName,flowData?.description,isActive);
    console.log('body for creating flow:::',body);
    if(body === 'error'){
      console.log('no obj name provided in start node');
      return;
    }
    // const flowPayload = {
    //     name: flowData?.name || '',
    //     model: flowData?.model || 'User',
    //     event: flowData?.event || 'before_create', // You can customize this as needed
    //     description: flowData?.description || '',
    //     mt_nodes: [], // Fill with actual nodes if available
    //     mt_transitions: [] // Fill with actual transitions if available
    // };
  
    // console.log('Payload to be saved:', JSON.stringify(flowPayload, null, 2));
    try {
        const apiService = new ApiService(`${BASE_URL}/create_flow`, {}, "POST", {
          mt_flow: body,
        });
  
        const response = await apiService.makeCall();
        // setSelectedFlowData([]);
        console.log('response for saving flow',response);
        message.success("Flow created successfully!");
      } catch (error) {
        message.error("Failed to create flow.");
      } finally {
        // setIsModalVisible(false);
        // setIsCreatingFlow(false);
        // setIsEditingFlow(false);
        // fetchFlows();
        navigate(-1);
      }
  };
  

  const handleSave = (values) =>{
    console.log('values on save',values);
    setFlowData(values);
  }
  const onCancel = () =>{
    console.log('object',object);
    // navigate(`/object-setup/${object?.object?._id}`)
    navigate(-1);
  };

  const handleRun = () => {
    console.log('Run triggered for flow:', flowData?.name);
  };

  const handleDebug = () => {
    console.log('Debug mode initiated for flow:', flowData?.name);
  };

  const handleActivateToggle = () => {
    setIsActive((prev) => !prev);
    console.log(isActive ? 'Flow Deactivated' : 'Flow Activated');
  };

  const handleSaveAsNewVersion = () => {
    console.log('Save as new version initiated for flow:', flowData?.name);
  };

  return (
    <>
      <div
        style={{
          width: '100%',
          height: '50px',
          backgroundColor: '#001F5B',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 16px',
          color: 'white',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          borderRadius: '10px'
        //   margin: '0px'
        }}
      >
        {/* Left section: Name + Gear Icon */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: '160px' }}>
          <div style={{ fontWeight: 'bold', fontSize: 16 }}>{flowData?.label ? flowData?.label : flowData?.name}</div>
          <SettingOutlined
            style={{ fontSize: 20, cursor: 'pointer' }}
            onClick={openModal}
          />
        </div>

        {/* Center: Action buttons */}
        {/* Right section with all action buttons */}
        <div style={{ minWidth: 'fit-content', display: 'flex', gap: '8px', justifyContent: 'flex-end', flex: 1 }}>
        <Button onClick={handleRun}>Run</Button>
        <Button onClick={handleDebug}>Debug</Button>
        <Button onClick={handleSaveAsNewVersion}>Save as New Version</Button>
        <Button type="primary" onClick={onSave}>Save</Button>
        <Button 
        onClick={onCancel}
        >
            Cancel
        </Button>
        <Button style={{width:"75px"}}
            type={isActive ? 'default' : 'primary'}
            danger={isActive}
            onClick={handleActivateToggle}
        >
            {isActive ? 'Deactivate' : 'Activate'}
        </Button>
        </div>
      </div>

      {/* Modal */}
      
      <FlowDetailsModalOnFlowScreen
        visible={modalVisible}
        onClose={closeModal}
        formData={flowData}
        onSave={handleSave}
      />
    </>
  );
};

export default TopUtilityBar;
